import { get } from 'lodash';

import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { Employment, Income } from '@funnels/types';

export default function filterOutPreviousIncomes(incomes: Income[], employments: Employment[] = []) {
  const filteredIncomes = incomes.filter((income: Income) => {
    const employmentId = get({ incomes: [income] }, FIELD_PATHS.INCOME_EMPLOYMENT_ID(0));

    // SE v2 incomes
    const companyClientId = get({ incomes: [income] }, FIELD_PATHS.INCOME_COMPANY_CLIENT_ID(0));

    // keep non employment incomes
    if (!employmentId && !companyClientId) {
      return true;
    }

    const employmentMatchById = employments.find((employment: Employment) => {
      return (
        get({ employments: [employment] }, FIELD_PATHS.EMPLOYMENT_ID(0)) === employmentId ||
        get({ employments: [employment] }, FIELD_PATHS.EMPLOYMENT_COMPANY_CLIENT_ID(0)) === companyClientId
      );
    });
    const employmentType = get({ employments: [employmentMatchById] }, FIELD_PATHS.EMPLOYMENT_TYPE(0));
    return !!employmentType && employmentType !== FIELD_VALUES.PREVIOUS;
  });

  return filteredIncomes;
}
